import styled from 'styled-components';
import { MediaQueries } from 'components/MediaQueries';

export const LoginContainerStyle = styled.div`
  background-color: ${({ theme }) => theme.mode === 'light' ? '#f8f8f8' : theme.Bg1};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .auth-content-container {
    @media (min-height: 765px) {
      height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  .img-container {
    max-width: 1230px;
    margin: 0 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .login-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      max-width: 1230px;
      margin: 0 auto;
    }
  }
  .company-brand-container {
    max-width: 1230px;
    margin: 0 auto;
    width: 100%;
    position: relative;
  }
  .company-brand {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0px;
    left: 10px;
    z-index: 1;
    svg {
      width: 45px;
      height: 45px;
    }
    .logo-title {
      color: #2b99f5;
      font-size: 28px;
      text-align: start;
      margin-left: 8px;
    }
  }

  @media only screen and (max-width: 400px) {
    .company-brand {
      margin-top: 18px;
    }
    .logo-title {
      display: none;
    }
  }

  .login-block {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
  }

  .logincard {
    width: 400px;
    height: fit-content;
    box-shadow: ${({ theme }) => theme.boxShadow1};
    border-radius: 20px;
    padding: 40px;
    background: ${({ theme }) => theme.colors[3]};
  }

  .policy-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    font-size: 13px;
    color: #828282;
    padding: 40px 0;
    z-index: 1;
    @media only screen and (max-width: 500px) {
      z-index: inherit;
    }
    > div {
      margin-right: 12px;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  @media only screen and (max-width: ${MediaQueries.tabletMaxwidth}) {
    .img-container {
      .login-img {
        display: none;
      }
    }
  }
  @media screen and (max-width: 550px) {
    .logincard,
    .login-block {
      width: 100%;
      padding: 0px;
      background: transparent;
    }
    .logincard {
      box-shadow: none;
    }
    .auth-content-container {
      padding: 0 20px;
    }
  }

  .removeBgShadow {
    top: 45%;
    box-shadow: none;
    background: initial;
  }

  .card-title {
    font-size: 23px;
    margin-top: 0;
    margin-bottom: 8px;
    text-align: center;
    position: relative;
    color: ${({ theme }) => theme.text1};
  }

  .inputbox {
    margin-top: 24px;
    .inputContainer {
      width: 100%;
      margin-top: 16px;
    }
    label {
      font-size: 16px;
    }
    .MuiAutocomplete-root {
      input {
        padding-right: 40px !important;
      }
    }
  }

  .date-container {
    margin-top: 18px;
    label {
      font-size: 15px;
    }
    .date-select-field {
      display: flex;
      justify-content: space-between;
      > div {
        width: 30%;
      }
    }
    .dob-helpertext {
      margin-top: 8px;
      font-size: 14px;
    }
  }

  .privacy-container {
    margin-top: 12px;
    font-size: 12px;
    text-align: center;
  }

  .login-errMsg {
    color: #d93025;
    display: flex;
    align-items: center;
    font-size: 13px;
    height: 20px;

    svg {
      width: 16px;
      height: 16px;
      margin-right: 4px;
      path {
        fill: #d93025;
      }
    }
  }

  .password-field-container {
    .inputContainer {
      width: 100%;
      margin-top: 16px;
    }
    label {
      font-size: 16px;
    }
  }

  .otp-field {
    margin-top: 24px;
    .inputContainer {
      width: 100%;
    }
    label {
      font-size: 16px;
    }
  }

  .back_btn {
    position: absolute;
    left: 0;
    top: 1px;
    button {
      background-color: #f3f3f4;
      border: none;
      :hover {
        background-color: #D6D5DC;
        color: ${({ theme }) => theme.colors[2]};
      }
    }
  }

  .link-styles {
    color: #016EDC !important;
    font-weight: 600;
    text-align: center;
    text-decoration: none;
    margin-top: 4px;
  }

  .footer-content {
    text-align: center;
    color: ${({ theme }) => theme.colors[2]};
  }

  .auth-action-btn {
    font-size: 16px;
    margin-top: 24px;
    width: 100%;
  }

  .align-end {
    width: 100%;
    display: flex;
    justify-content: end;
  }

  .auth-btn-wrapper {
    width: 100%;
    .MuiDivider-root {
      margin: 22px 0;
      font-size: 13px;
    }
  }

  .auth-social-btns {
    display: flex;
    gap: 8px;
    > div {
      width: 50%;
    }
  }

  .auth-footer {
    color: ${({ theme }) => theme.text1};
    text-align: center;
    margin-top: 20px;
    a {
      padding-left: 8px;
    }
  }

  .helper-title {
    text-align: center;
    padding-bottom: 10px;
    color: ${({ theme }) => theme.gray[1]};
  }

  .otp-resend {
    width: 100%;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    span {
      margin-right: 8px;
    }
    div {
      min-width: 86px;
    }
    > a {
      cursor: pointer;
      font-weight: bold;
      color: #016EDC;
    }
  }

  a:hover {
    text-decoration: underline;
  }
  .no-page-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 0 80px 0;
    font-weight: 600;
    font-size: 28px;
    svg {
      width: 250px;
      height: 250px;
      margin-bottom: 10px;
      path,
      line {
        stroke: rgb(9, 123, 237);
      }
    }
    button {
      margin-top: 20px;
      font-size: 16px;
    }
  }
  .auth-apploication-title {
    font-size: 1.5em;
    font-weight: 600;
    width: 100%;
    margin: 80px 0 40px;
    color: ${({ theme }) => theme.mode === 'light' ? '#455a64' : '#88b1c4'};
    text-align: center;
    display: flex;
    justify-content: center;
    > div {
      max-width: 550px;
    }
  }
  .option-header {
    position: absolute;
    right: 10px;
    top: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    z-index: 99;
  }
  .icon-style {
    fill: ${({ theme }) => theme.svg1};
    &:hover {
      cursor: pointer;
      fill: #1976d2;
    }
  }
  @media screen and (max-width: 460px) {
    .auth-apploication-title {
      font-size: 19px;
    }
  }
`;

export const LoginNotificationContainer = styled.div`
  text-align: center;
  padding: 12px;
  .title {
    font-size: 22px;
    font-weight: 600;
    color: ${({ theme }) => theme.text1};
  }
  .description {
    font-size: 18px;
    margin: 24px 0;
    color: ${({ theme }) => theme.fieldText1};
  }
  .action-btn {
    display: flex;
    justify-content: center;
    > button {
      margin: 0 6px;
      width: 100px;
    }
  }
`;

export const AuthButtonWrapper = styled.div`
  .custom-google-btn {
    padding: 2px 8px 2px 6px;
    font-size: 16px;
    border-radius: 4px !important;
    width: 100%;
    color: ${({ theme }) => theme.text1};
    font-weight: 500;
    white-space: nowrap;
    border: 1px solid ${({ theme }) => theme.fieldBorder1};
    height: 44px !important;
    .MuiButton-icon {
      margin-right: 0px;
    }
    svg {
      margin: 0px 16px;
      width: 16px;
      height: 16px;
    }
    &:hover {
      border-color: ${({ theme }) => theme.fieldBorder1};
      background-color: ${({ theme }) => theme.hoverBg1};
    }
  }
  .custom-apple-btn {
    .apple-icon {
      font-size: 20px;
      margin-right: 12px;
    }
  }
`;